import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm } from 'react-hook-form'

import { Button, Alert } from 'components/Elements'
import { validationSchema } from './validation'
import { TextInput, FormFieldController } from 'components/FormElements'
import { useFormSubmit } from 'hooks'

export const CategoryForm = ({ initialValues, ...props }) => {
  const { t } = useTranslation()

  const defaultValues = {
    title: '',
    ...initialValues,
  }

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema),
  })

  const {
    control,
    handleSubmit,
    setError,
    formState: { isSubmitting },
  } = methods

  const { error: submitError, onSubmit: onFormSubmit } = useFormSubmit({
    submit: props.onSubmit,
    setError,
  })

  const onSubmit = async data => {
    try {
      await onFormSubmit(data)
    } catch (error) {}
  }

  return (
    <>
      <FormProvider {...methods}>
        {submitError && <Alert type={'error'}>{submitError?.message || t('error')}</Alert>}

        <form onSubmit={handleSubmit(onSubmit)}>
          <FormFieldController
            name={'title'}
            control={control}
            component={TextInput}
            id={'title'}
            label={t('title')}
            placeholder={t('title')}
          />

          <div className="mt-3 pt-3">
            <div className="text-center">
              <Button type={'submit'} disabled={isSubmitting} loading={isSubmitting}>
                {t('save')}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  )
}

CategoryForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
}
